import { ChartSeries } from 'helpers/chartDataProcessors';
import { TableChart } from './TableChart';

interface TableChartBarProps {
  chartData: ChartSeries[] | undefined;
}

/** The table with a bar under each number. */
export const TableChartBar = ({ chartData }: TableChartBarProps) => <TableChart chartData={chartData} bars />;
